module.exports = __webpack_public_path__ + "static/img/dms_banner.fb67d4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dms_banner.svg
// module id = gymE
// module chunks = 1